import styled from 'styled-components'
import { FilterContainerType, IFilterRedirectProps } from './types'

export const FilterContainer = styled.div<FilterContainerType>`
  /* margin: ${({ marginContainer }) => marginContainer || '40px 0'}; */
`
